"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
var _mapCanBeReserved = require("./mapCanBeReserved");
Object.keys(_mapCanBeReserved).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapCanBeReserved[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapCanBeReserved[key];
    }
  });
});
var _mapCanBeSold = require("./mapCanBeSold");
Object.keys(_mapCanBeSold).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapCanBeSold[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapCanBeSold[key];
    }
  });
});
var _mapCanBeSubscribed = require("./mapCanBeSubscribed");
Object.keys(_mapCanBeSubscribed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapCanBeSubscribed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapCanBeSubscribed[key];
    }
  });
});
var _mapHasAutoSubscription = require("./mapHasAutoSubscription");
Object.keys(_mapHasAutoSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapHasAutoSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapHasAutoSubscription[key];
    }
  });
});
var _mapLabels = require("./mapLabels");
Object.keys(_mapLabels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapLabels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapLabels[key];
    }
  });
});
var _mapProductBoxesFromGql = require("./mapProductBoxesFromGql");
Object.keys(_mapProductBoxesFromGql).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductBoxesFromGql[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductBoxesFromGql[key];
    }
  });
});
var _mapProductBoxesFromStaticApi = require("./mapProductBoxesFromStaticApi");
Object.keys(_mapProductBoxesFromStaticApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductBoxesFromStaticApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductBoxesFromStaticApi[key];
    }
  });
});
var _mapProductBoxPropsFromGql = require("./mapProductBoxPropsFromGql");
Object.keys(_mapProductBoxPropsFromGql).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductBoxPropsFromGql[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductBoxPropsFromGql[key];
    }
  });
});
var _mapProductBoxPropsFromStaticApi = require("./mapProductBoxPropsFromStaticApi");
Object.keys(_mapProductBoxPropsFromStaticApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductBoxPropsFromStaticApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductBoxPropsFromStaticApi[key];
    }
  });
});
var _mapShade = require("./mapShade");
Object.keys(_mapShade).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShade[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShade[key];
    }
  });
});
var _mapShades = require("./mapShades");
Object.keys(_mapShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShades[key];
    }
  });
});
var _mapShowQuickBuyButton = require("./mapShowQuickBuyButton");
Object.keys(_mapShowQuickBuyButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShowQuickBuyButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShowQuickBuyButton[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
